import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Formik } from 'formik';

import { LoginSchema } from '../../../../../shared/utils/loginSchemaHelper';
import encode from '../../../../../shared/utils/encodeToUrl';
import useLogin from '../../hooks/useLogin';
import SharedLoginForm from '../../shared/SharedLoginForm';

const CustomLoginForm = () => {
  const customLoginInfo = useSelector((state) => state.auth.data.customLoginData);

  const [googleLoginWidth, setGoogleLoginWidth] = useState('322');

  const {
    handleLogin,
  } = useLogin();

  useEffect(() => {
    const handleResize = () => {
      setGoogleLoginWidth(window.innerWidth < 600 ? '270' : '322');
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Formik
      initialValues={{
        client_id: process.env.CLIENT_ID,
        client_secret: process.env.CLIENT_SECRET,
        grant_type: 'password',
        password: '',
        scope: 'offline_access',
        username: '',
      }}
      onSubmit={(values) => {
        handleLogin(encode(values));
      }}
      validationSchema={LoginSchema}
      render={({
        errors,
        handleSubmit,
        touched,
        values,
      }) => (
        <SharedLoginForm
          customLoginInfo={customLoginInfo}
          errors={errors}
          googleLoginWidth={googleLoginWidth}
          handleSubmit={handleSubmit}
          touched={touched}
          values={values}
        />
      )}
    />
  );
};

export default CustomLoginForm;
